import { useEffect, useState } from 'react';

/**
 * The current year, kept live: it flips over at midnight on New Year's Eve even if the page is
 * left open, and re-checks whenever the tab comes back into view (timers sleep in background tabs).
 */
export function useCurrentYear() {
  const [year, setYear] = useState(() => new Date().getFullYear());

  useEffect(() => {
    let timer = 0;
    const sync = () => {
      const now = new Date();
      setYear(now.getFullYear());
      window.clearTimeout(timer);
      const nextYear = new Date(now.getFullYear() + 1, 0, 1).getTime();
      // Browsers cap timeouts at ~24.8 days; re-arm in steps until the new year arrives
      timer = window.setTimeout(sync, Math.min(nextYear - now.getTime() + 1000, 2_000_000_000));
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') sync();
    };
    sync();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return year;
}
